import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import { getActionCompletedTime } from '../../utils/actionTiming';
import apiTracking from '../../utils/tracking/apiTracking';

let globalFallbackWasCompleted = false;
export function trackCompleteGlobalFallbackAction(state) {
	if (globalFallbackWasCompleted) return;
	globalFallbackWasCompleted = true;

	apiTracking.trackActionInit(state);

	const actionCompleteTime = getActionCompletedTime(state)();
	apiTracking.trackActionCompleted(state, actionCompleteTime);

	sendGoogleAnalyticsEvent(googleAnalyticsEvents.GLOBAL_FALLBACK_ACTION, {
		...state.widget,
		action: state.widget.activeAction,
		actionCompleteTime
	});
}
